module.exports = __webpack_public_path__ + "img/partfour_pic2.f5f3c70a.jpeg";